//@flow
import React from 'react';
import { browserHistory } from 'react-router';
import IconClose from '../../Icon/components/IconClose.react';
import AccountActions from '../../Actions/account';

type State = {
  isOpen:boolean,
};

export default class SetPasswordNotification extends React.Component<{}, State> {
  state = {
    isOpen: true,
  };

  closeNotification = () => {
    this.setState({
      isOpen: false,
    });
  };

  openSetPasswordModal() {
    browserHistory.push('/account?acc_set_pass_open=true');
    // In case current location is already /account
    AccountActions.openPasswordModal();
  }

  render() {
    if (!this.state.isOpen) return null;

    return (
      <div className="set-password-notification">
        <div className="set-password-notification-content">
          <span className="set-password-link link" onClick={this.openSetPasswordModal}>Set a password </span>
          to keep track of the order status and get early access to new and limited edition snacks.
          <IconClose closeAction={this.closeNotification} className="password-reminder" />
        </div>
      </div>
    );
  }
}
